export default "__VITE_ASSET__DnSjMliO__"